<template>
  <div>
    <!-- نمایش مربع‌های رنگ -->
    <div class="color-squares-container">
      <div class="color-square-wrapper">
        <div
          class="color-square header-color"
          :style="{ background: headerColor }"
          @click="openColorPicker('header')"
        >
          <span class="color-label">{{ headerLabel }}</span>
        </div>
      </div>
      <div class="color-square-wrapper">
        <div
          class="color-square body-color"
          :style="{ background: bodyColor }"
          @click="openColorPicker('body')"
        >
          <span class="color-label">{{ bodyLabel }}</span>
        </div>
      </div>
      <div class="color-square-wrapper">
        <div
          class="color-square text-color"
          :style="{ background: textColor }"
          @click="openColorPicker('text')"
        >
          <span class="color-label">{{ textLabel }}</span>
        </div>
      </div>
    </div>

    <!-- پاپ‌آپ انتخاب رنگ -->
    <custom-popup
      v-model="showColorPicker"
      :cons="popupConfig"
      max-width="600"
      hide-confirm
    >
      <v-container class="pa-4">
        <!-- برای رنگ متن فقط یک تب -->
        <div v-if="currentType === 'text'">
          <h4 class="mb-4 text-center">انتخاب رنگ متن</h4>
          <v-row no-gutters>
            <v-col
              v-for="(color, i) in displayedColors"
              :key="i"
              class="pa-2"
              cols="3"
              lg="1"
              md="2"
            >
              <v-avatar
                :color="color"
                class="rounded-lg border cursor-pointer color-swatch"
                size="40"
                @click="onColorSwatchClick(color)"
              >
                <v-icon v-if="currentColor === color" color="white" small>
                  mdi-check
                </v-icon>
              </v-avatar>
            </v-col>
          </v-row>
          <v-row v-if="!showAllColors" class="mt-4">
            <v-col cols="12" class="text-center">
              <v-btn
                @click="showAllColors = true"
                color="primary"
                outlined
                class="more-btn"
                :loading="loadingMore"
              >
                <v-icon left>mdi-plus</v-icon>
                نمایش رنگ‌های بیشتر
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-else class="mt-4">
            <v-col cols="12" class="text-center">
              <v-btn
                @click="showAllColors = false"
                color="secondary"
                outlined
                class="back-btn"
              >
                <v-icon left>mdi-arrow-up</v-icon>
                بازگشت به رنگ‌های استاندارد
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <!-- برای هدر و بدنه دو تب -->
        <custom-tabs
          v-else
          v-model="activeTab"
          :tab-items="[
            { text: 'رنگ ساده', icon: 'palette' },
            { text: 'طیف رنگی', icon: 'gradient' },
          ]"
          grow
        >
          <template v-slot:staticItems>
            <!-- تب رنگ ساده -->
            <v-tab-item class="pa-4">
              <v-row no-gutters>
                <v-col
                  v-for="(color, i) in displayedColors"
                  :key="i"
                  class="pa-2"
                  cols="3"
                  lg="1"
                  md="2"
                >
                  <v-avatar
                    :color="color"
                    class="rounded-lg border cursor-pointer color-swatch"
                    size="40"
                    @click="onColorSwatchClick(color)"
                  >
                    <v-icon v-if="currentColor === color" color="white" small>
                      mdi-check
                    </v-icon>
                  </v-avatar>
                </v-col>
              </v-row>
              <v-row v-if="!showAllColors" class="mt-4">
                <v-col cols="12" class="text-center">
                  <v-btn
                    @click="showAllColors = true"
                    color="primary"
                    outlined
                    class="more-btn"
                    :loading="loadingMore"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    نمایش رنگ‌های بیشتر
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-else class="mt-4">
                <v-col cols="12" class="text-center">
                  <v-btn
                    @click="showAllColors = false"
                    color="secondary"
                    outlined
                    class="back-btn"
                  >
                    <v-icon left>mdi-arrow-up</v-icon>
                    بازگشت به رنگ‌های استاندارد
                  </v-btn>
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- تب طیف رنگی -->
            <v-tab-item class="pa-4">
              <v-row no-gutters>
                <v-col
                  v-for="(gradient, i) in displayedGradients"
                  :key="i"
                  class="pa-2"
                  cols="3"
                  md="2"
                  lg="1"
                >
                  <v-avatar
                    :style="{
                      background: `linear-gradient(45deg, ${gradient.colors[0]}, ${gradient.colors[1]})`,
                    }"
                    class="border cursor-pointer gradient-swatch"
                    size="40"
                    @click="onGradientSwatchClick(gradient)"
                  >
                    <v-icon
                      v-if="isSelectedGradient(gradient)"
                      color="white"
                      small
                    >
                      mdi-check
                    </v-icon>
                  </v-avatar>
                </v-col>
              </v-row>
              <v-row v-if="!showAllGradients" class="mt-4">
                <v-col cols="12" class="text-center">
                  <v-btn
                    @click="showAllGradients = true"
                    color="primary"
                    outlined
                    class="more-btn"
                    :loading="loadingMore"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    نمایش رنگ‌های بیشتر
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-else class="mt-4">
                <v-col cols="12" class="text-center">
                  <v-btn
                    @click="showAllGradients = false"
                    color="secondary"
                    outlined
                    class="back-btn"
                  >
                    <v-icon left>mdi-arrow-up</v-icon>
                    بازگشت به رنگ‌های استاندارد
                  </v-btn>
                </v-col>
              </v-row>
            </v-tab-item>
          </template>
        </custom-tabs>
      </v-container>
    </custom-popup>
  </div>
</template>

<script>
export default {
  name: "ColorPickerPopup",

  props: {
    value: {
      type: Object,
      required: true,
    },
    headerLabel: {
      type: String,
      default: "هدر",
    },
    bodyLabel: {
      type: String,
      default: "بدنه",
    },
    textLabel: {
      type: String,
      default: "متن",
    },
  },

  data() {
    return {
      showColorPicker: false,
      activeTab: 0,
      currentType: "header",
      currentColor: "#EC5252",
      showAllColors: false,
      showAllGradients: false,
      loadingMore: false,
      colors: [
        "#FFFFFF",
        "#000000",
        "#2F4F4F",
        "#DC143C",
        "#FF4500",
        "#FF8C00",
        "#FFD700",
        "#ADFF2F",
        "#32CD32",
        "#00CED1",
        "#1E90FF",
        "#9370DB",
        "#EC5252",
        "#C14444",
        "#EF717A",
        "#D95459",
        "#FF8976",
        "#F56149",
        "#F392B9",
        "#EA4C8C",
        "#5E345E",
        "#4F2B4F",
        "#B659AB",
        "#8F3D86",
        "#9B59B6",
        "#8E44AD",
        "#745EC5",
        "#5B48A2",
        "#5065A1",
        "#394C81",
        "#3498DB",
        "#2980B9",
        "#34495E",
        "#2C3E50",
        "#3A6F81",
        "#356272",
        "#345F41",
        "#2D5036",
        "#1ABC9C",
        "#16A085",
        "#2ECC71",
        "#27AE60",
        "#A5C63B",
        "#8EB021",
        "#F5C24E",
        "#FCB424",
        "#F68F30",
        "#C66913",
        "#79302A",
        "#662621",
        "#5E4534",
        "#503B2C",
        "#8E8271",
        "#7B7163",
        "#F0DEB4",
        "#D5C295",
        "#B8C9F1",
        "#48ABD5",
        "#ECF0F1",
        "#BDC3C7",
        "#95A5A6",
        "#7F8C8D",
        "#A0CECB",
        "#7DB1B1",
        "#CFF09E",
        "#A8DBA8",
      ],
      allGradients: [
        { type: "linear", colors: ["#FF6B6B", "#4ECDC4"] },
        { type: "linear", colors: ["#A8E6CF", "#DCEDC8"] },
        { type: "linear", colors: ["#FFD3B6", "#FFAAA5"] },
        { type: "linear", colors: ["#DDA0DD", "#98D8C8"] },
        { type: "linear", colors: ["#FFB347", "#FFCC5C"] },
        { type: "linear", colors: ["#87CEEB", "#98FB98"] },
        { type: "linear", colors: ["#DDA0DD", "#F0E68C"] },
        { type: "linear", colors: ["#FF69B4", "#87CEEB"] },
        { type: "linear", colors: ["#98FB98", "#FFB6C1"] },
        { type: "linear", colors: ["#F0E68C", "#DDA0DD"] },
        { type: "linear", colors: ["#A18CD1", "#FBC2EB"] },
        { type: "linear", colors: ["#F6D365", "#FDA085"] },
        { type: "linear", colors: ["#D4FC79", "#96E6A1"] },
        { type: "linear", colors: ["#F1BEF7", "#C27BA5"] },
        { type: "linear", colors: ["#DFCB99", "#A69166"] },
        { type: "linear", colors: ["#A4E7D6", "#61C68C"] },
        { type: "linear", colors: ["#FDA893", "#D16E5E"] },
        { type: "linear", colors: ["#FEE370", "#E1C548"] },
        { type: "linear", colors: ["#84FAB0", "#8FD3F4"] },
        { type: "linear", colors: ["#A6C0FE", "#F68084"] },
        { type: "linear", colors: ["#30CFD0", "#330867"] },
        { type: "linear", colors: ["#FA709A", "#FEE140"] },
        { type: "linear", colors: ["#5EE7DF", "#B490CA"] },
        { type: "linear", colors: ["#667EEA", "#764BA2"] },
        { type: "linear", colors: ["#48C6EF", "#6F86D6"] },
        { type: "linear", colors: ["#FF0844", "#FFB199"] },
        { type: "linear", colors: ["#92FE9D", "#00C9FF"] },
        { type: "linear", colors: ["#FF758C", "#FF7EB3"] },
        { type: "linear", colors: ["#868F96", "#596164"] },
        { type: "linear", colors: ["#C79081", "#DFA579"] },
        { type: "linear", colors: ["#ABECD6", "#FBED96"] },
        { type: "linear", colors: ["#16A085", "#F4D03F"] },
        { type: "linear", colors: ["#FF5858", "#F09819"] },
        { type: "linear", colors: ["#E14FAD", "#F9D423"] },
        { type: "linear", colors: ["#C1C161", "#D4D4B1"] },
        { type: "linear", colors: ["#CBBACC", "#2580B3"] },
        { type: "linear", colors: ["#FF1B6B", "#45CAFF"] },
        { type: "linear", colors: ["#432371", "#FAAE7B"] },
        { type: "linear", colors: ["#EF745C", "#34073D"] },
        { type: "linear", colors: ["#FFA8BD", "#242ACF"] },
        { type: "linear", colors: ["#83F5E5", "#E761BD"] },
        { type: "linear", colors: ["#A4C6B8", "#5E435D"] },
        { type: "linear", colors: ["#DCF180", "#35518A"] },
        { type: "linear", colors: ["#22052D", "#CCB3D1"] },
        { type: "linear", colors: ["#E2D9D2", "#AAC9CE"] },
        { type: "linear", colors: ["#B6B3C4", "#DCC2CD"] },
        { type: "linear", colors: ["#A5C7B7", "#5D4257"] },
        { type: "linear", colors: ["#04619F", "#000000"] },
        { type: "linear", colors: ["#B82E1F", "#000000"] },
        { type: "linear", colors: ["#D58936", "#69140E"] },
        { type: "linear", colors: ["#44000B", "#E0455F"] },
        { type: "linear", colors: ["#313131", "#6DADDB"] },
        { type: "linear", colors: ["#59090C", "#DA898C"] },
        { type: "linear", colors: ["#E7C1CE", "#F2D6D2"] },
        { type: "linear", colors: ["#F4DCD0", "#BDBBC0"] },
        { type: "linear", colors: ["#A5CAD2", "#ED8897"] },
        { type: "linear", colors: ["#A7D676", "#83C8B4"] },
        { type: "linear", colors: ["#EEBD89", "#D13ABD"] },
        { type: "linear", colors: ["#AEBAF8", "#9600FF"] },
        { type: "linear", colors: ["#F6EA41", "#F048C6"] },
        { type: "linear", colors: ["#FF8DDB", "#BB73E0"] },
        { type: "linear", colors: ["#C1FCD3", "#0CCDA3"] },
        { type: "linear", colors: ["#AEBAF8", "#C973FF"] },
        { type: "linear", colors: ["#F2F5D0", "#F9957F"] },
        { type: "linear", colors: ["#D592FF", "#B60F46"] },
        { type: "linear", colors: ["#F6EFA7", "#FF0078"] },
        { type: "linear", colors: ["#BFFFC7", "#849B5C"] },
        { type: "linear", colors: ["#E65758", "#771D32"] },
        { type: "linear", colors: ["#C22ED0", "#5FFAE0"] },
        { type: "linear", colors: ["#9FA5D5", "#E8F5C8"] },
        { type: "linear", colors: ["#F2BAE8", "#0C7BB3"] },
        { type: "linear", colors: ["#F6B2E1", "#58126A"] },
        { type: "linear", colors: ["#D9ECC7", "#07A3B2"] },
        { type: "linear", colors: ["#CCFBFF", "#EF96C5"] },
        { type: "linear", colors: ["#50D5B7", "#067D68"] },
        { type: "linear", colors: ["#A9A9A9", "#808080"] },
        { type: "linear", colors: ["#696969", "#2F4F4F"] },
        { type: "linear", colors: ["#FF1493", "#DC143C"] },
        { type: "linear", colors: ["#FF4500", "#FF6347"] },
        { type: "linear", colors: ["#FF8C00", "#FFA500"] },
        { type: "linear", colors: ["#FFD700", "#FFFF00"] },
        { type: "linear", colors: ["#ADFF2F", "#7FFF00"] },
        { type: "linear", colors: ["#32CD32", "#00FF00"] },
        { type: "linear", colors: ["#00CED1", "#40E0D0"] },
        { type: "linear", colors: ["#1E90FF", "#00BFFF"] },
        { type: "linear", colors: ["#9370DB", "#8A2BE2"] },
        { type: "linear", colors: ["#FF69B4", "#FF1493"] },
        { type: "linear", colors: ["#FFB6C1", "#FFC0CB"] },
        { type: "linear", colors: ["#F0E68C", "#FFFFE0"] },
        { type: "linear", colors: ["#98FB98", "#90EE90"] },
        { type: "linear", colors: ["#87CEEB", "#87CEFA"] },
        { type: "linear", colors: ["#DDA0DD", "#EE82EE"] },
        { type: "linear", colors: ["#F5DEB3", "#DEB887"] },
        { type: "linear", colors: ["#BC8F8F", "#CD853F"] },
        { type: "linear", colors: ["#CCFBFF", "#EF96C5"] },
        { type: "linear", colors: ["#50D5B7", "#067D68"] },
        { type: "linear", colors: ["#F2ECB6", "#A96F44"] },
        { type: "linear", colors: ["#FEA858", "#ED765E"] },
      ],
      popupConfig: {
        title: "انتخاب رنگ",
        buttons: [
          {
            type: "submit",
            handler: this.applyColor,
            disabled: () => !this.currentColor,
          },
        ],
      },
    };
  },

  computed: {
    headerColor() {
      return this.value.headerColor || "#AA7630";
    },
    bodyColor() {
      return this.value.bodyColor || "#EBCB63";
    },
    textColor() {
      return this.value.textColor || "#000000";
    },
    displayedColors() {
      return this.showAllColors ? this.colors : this.colors.slice(0, 12);
    },
    displayedGradients() {
      return this.showAllGradients
        ? this.allGradients
        : this.allGradients.slice(0, 12);
    },
  },

  methods: {
    openColorPicker(type) {
      this.currentType = type;
      this.currentColor =
        type === "header"
          ? this.headerColor
          : type === "body"
          ? this.bodyColor
          : this.textColor;
      this.showColorPicker = true;
      this.showAllColors = false;
      this.showAllGradients = false;
    },

    onColorSwatchClick(color) {
      this.currentColor = color;
      this.applyColor();
    },

    onGradientSwatchClick(gradient) {
      this.currentColor = `linear-gradient(45deg, ${gradient.colors[0]}, ${gradient.colors[1]})`;
      this.applyColor();
    },

    isSelectedGradient(gradient) {
      const gradientString = `linear-gradient(45deg, ${gradient.colors[0]}, ${gradient.colors[1]})`;
      return this.currentColor === gradientString;
    },

    applyColor() {
      const newValue = { ...this.value };

      if (this.currentType === "header") {
        newValue.headerColor = this.currentColor;
      } else if (this.currentType === "body") {
        newValue.bodyColor = this.currentColor;
      } else if (this.currentType === "text") {
        newValue.textColor = this.currentColor;
      }

      this.$emit("input", newValue);
      this.showColorPicker = false;
    },
  },
};
</script>

<style scoped lang="scss">
.color-squares-container {
  display: flex;
  flex-direction: row;
  gap: 6px;
  margin-bottom: 16px;
}

.color-square-wrapper {
  display: flex;
  justify-content: center;
}

.color-square {
  width: 60px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: left 0.5s ease;
  }

  &:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.3);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(-2px) scale(0.98);
  }
}

.color-label {
  color: white;
  font-weight: 600;
  font-size: 12px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  z-index: 1;
  position: relative;
}

.color-swatch {
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;

  &:hover {
    transform: scale(1.15);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
  }

  &:active {
    transform: scale(1.1);
  }
}

.gradient-swatch {
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
    border-color: rgba(255, 255, 255, 0.6);
  }

  &:active {
    transform: scale(1.05);
  }
}

.more-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 25px;
  padding: 8px 24px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(25, 118, 210, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
}

.back-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 25px;
  padding: 8px 24px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(139, 139, 139, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
}

.v-text-field {
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
  }
}

.v-tab-item {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.v-avatar {
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      45deg,
      transparent 30%,
      rgba(255, 255, 255, 0.1) 50%,
      transparent 70%
    );
    transform: translateX(-100%);
    transition: transform 0.6s ease;
  }

  &:hover::after {
    transform: translateX(100%);
  }
}
</style>
